module.exports = __webpack_public_path__ + "static/media/logo confindustria orizz.b57a2a9a.png";